import { render, staticRenderFns } from "./AccettazioneSsnImpegnativaModalComponent.vue?vue&type=template&id=32fb5361&scoped=true"
import script from "./AccettazioneSsnImpegnativaModalComponent.vue?vue&type=script&lang=js"
export * from "./AccettazioneSsnImpegnativaModalComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32fb5361",
  null
  
)

export default component.exports